import { BRAND_NAME, language } from "@chef/constants";

export const intl = (
  {
    no: {
      YOU_HAVE_ORDERED_A_CAMPAIGN_DELIVERY_FOR_THIS_WEEK:
        "Du har bestilt en kampanjelevering for denne uken som leveres ",
      THIS_ORDER_REMAINS: "Denne ordren er fortsatt",
      ACTIVE: "aktiv",
      YOU_CAN_MAKE_CHANGES: "Du kan gjøre endringer på din kampanjelevering ",
      HERE: "her",
      WARNING: "Obs!",
      CAMPAIGN_ORDER_BOOKED: "Kampanjelevering bestilt!",
      ORDER_HERE: "Bestill her",
    },
    se: {
      YOU_HAVE_ORDERED_A_CAMPAIGN_DELIVERY_FOR_THIS_WEEK:
        "Du har beställt en kampanjleverans för denna vecka som planeras komma ",
      THIS_ORDER_REMAINS: "Denna order är fortfarande",
      ACTIVE: "aktiv",
      YOU_CAN_MAKE_CHANGES: "Du kan göra ändringar på din kampanjleverans ",
      HERE: "här",
      WARNING: "Vänligen notera!",
      CAMPAIGN_ORDER_BOOKED: "Kampanjleverans bokad!",
      ORDER_HERE: "Beställ här",
    },
    dk: {
      YOU_HAVE_ORDERED_A_CAMPAIGN_DELIVERY_FOR_THIS_WEEK:
        "Du har bestilt en kampagnelevering for denne ugen som leveres",
      THIS_ORDER_REMAINS: "Denne ordre er stadig",
      ACTIVE: "aktiv",
      YOU_CAN_MAKE_CHANGES:
        "Du kan foretage ændringer på din kampagnelevering ",
      HERE: "her",
      WARNING: "Bemærk venligst!",
      CAMPAIGN_ORDER_BOOKED: "Kampagnelevering bestilt!",
      ORDER_HERE: "Bestil her",
    },
  } as const
)[language];

export const brand = (
  {
    AMK: {
      CAMPAIGN_CTA_CARD_TITLE: "Adams Lammelårkasse",
      CAMPAIGN_CTA_CARD_DESCRIPTION:
        "Kom i påskestemning med Adams Lammelårkasse! En fantastisk påskemiddag til 6-8 personer.",
      IMAGE_URL:
        "https://ggfrontendassets.azureedge.net/publicassets/adamsmatkasse/600x400-paske-amk.jpg",
    },
    GL: {
      CAMPAIGN_CTA_CARD_TITLE: "Lammelårkassen fra Godtlevert",
      CAMPAIGN_CTA_CARD_DESCRIPTION:
        "Vårt kokketeam har satt sammen en fantastisk kasse med alt du trenger til påskemiddagen!",
      IMAGE_URL:
        "https://ggfrontendassets.azureedge.net/publicassets/godtlevert/600x400-paske-gl.jpg",
    },
    LMK: {
      CAMPAIGN_CTA_CARD_TITLE: "Linas Påskbord",
      CAMPAIGN_CTA_CARD_DESCRIPTION:
        "Linas Påskbord är tillbaka! Våra kockar har gjort det igen - tagit fram ett klassiskt påskbord med en liten twist.",
      IMAGE_URL:
        "https://ggfrontendassets.azureedge.net/publicassets/linasmatkasse/600x400-paske-lmk.jpg",
    },
    RN: {
      CAMPAIGN_CTA_CARD_TITLE: "Påskbord",
      CAMPAIGN_CTA_CARD_DESCRIPTION:
        "Påskbord är tillbaka! Våra kockar har gjort det igen - tagit fram ett klassiskt påskbord med en liten twist.",
      IMAGE_URL: "",
    },
  } as const
)[BRAND_NAME];
